import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component( {
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
} )
export class ErrorComponent implements OnInit {
  header: string = "The server returned an error that is not handled properly in STR UI."
  constructor(
    private activeRoute: ActivatedRoute,) { }

    ngOnInit() {
      this.activeRoute.queryParams.subscribe( params => {
          if ( params['message'] ) {
              this.header = params['message'] ;
          }
      } );
  }


}
